
import React from 'react';

function SquareBox(props) {
    const {color} = props
    return <div className={`square-box square-box-${color}`}></div>;
}

export default SquareBox;
